import { formatTimeRemaining } from "@nova/format"
import { useTick } from "./ticker"

export const useMsRemaining = ({ timestamp }: { timestamp: number | undefined }) => {
    useTick(1000)
    return timestamp === undefined ? undefined : timestamp - Date.now()
}

export const useTimeRemaining = ({ timestamp }: { timestamp: number | undefined }) => {
    const msRemaining = useMsRemaining({ timestamp })
    return msRemaining === undefined ? "" : formatTimeRemaining(msRemaining)
}
